<template>
  <div class="product">
    <banner :img="require('@/assets/img/slogn.png')" title="产品介绍" :height="180" />
    <div class="product-content" v-loading="loading">
      <!-- 介绍视频 -->
      <section class="section section-video">
        <div class="section-header">
          <h3 class="title">介绍视频</h3>
          <p class="eTitle">PRODUCT VIDEO</p>
          <div class="section-line"></div>
        </div>
        <div class="p-video">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
        </div>
      </section>

      <!-- 传统BMS模式不足 -->
      <section class="section section-lacking">
        <div class="section-header">
          <h3 class="title">传统BMS模式不足</h3>
          <p class="eTitle">TRADITIONAL DEFICIENCY</p>
          <div class="section-line"></div>
        </div>
        <div class="lacking-bottom">
          <div class="lacking-bottom-item" v-for="(item, index) in lackingList" :key="index">
            <div class="lacking-bottom-item-img">
              <img :src="item.icon" :alt="item.title" />
            </div>
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </section>

      <!-- 平台目标 -->
      <section class="section section-target">
        <div class="section-header">
          <h3 class="title">平台目标</h3>
          <p class="eTitle">TARGET</p>
          <div class="section-line"></div>
        </div>
        <div class="target-img">
          <img src="../assets/img/product_group_3_img.png" alt="平台目标" />
        </div>
      </section>

      <!-- 功能模块 -->
      <section class="section section-modular">
        <div class="section-header">
          <h3 class="title">功能模块</h3>
          <p class="eTitle">FUNCTIONAL MODULES</p>
          <div class="section-line"></div>
        </div>
        <div class="modular-content">
          <div class="modular-content-same left">
            <div class="same-item" v-for="(item, index) in leftModules" :key="index">
              <div class="same-item-img">
                <img :src="item.icon" :alt="item.name" />
              </div>
              <p>{{ item.name }}</p>
            </div>
          </div>
          <div class="modular-content-center">
            <img src="../assets/img/product_group_4_img.png" alt="功能模块中心" />
          </div>
          <div class="modular-content-same right">
            <div class="same-item" v-for="(item, index) in rightModules" :key="index">
              <p>{{ item.name }}</p>
              <div class="same-item-img">
                <img :src="item.icon" :alt="item.name" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      loading: true,
      lackingList: [
        {
          icon: require("../assets/img/product-group-icon_3.png"),
          title: "质量安全隐患",
          desc: "质量检查、安全检查以抽查为主，难免存在遗漏，留下质量安全隐患。"
        },
        {
          icon: require("../assets/img/product-group-icon_2.png"),
          title: "数据支撑缺失",
          desc: "数据统计、数据分析的缺失，无法为统计、分析、项目评估等工作提供数据支撑。"
        },
        {
          icon: require("../assets/img/product-group-icon_1.png"),
          title: "追溯性不足",
          desc: "检查工作和检查记录文件脱节，无法做到同步对应；缺少影像文档，无法做到可追溯性。"
        }
      ],
      leftModules: [
        { icon: require("../assets/img/product-group_4-icon_1.png"), name: "质量控制模块" },
        { icon: require("../assets/img/product-group_4-icon_2.png"), name: "知识仓库模块" },
        { icon: require("../assets/img/product-group_4-icon_3.png"), name: "信息流程模块" },
        { icon: require("../assets/img/product-group_4-icon_1.png"), name: "定位复核模块" }
      ],
      rightModules: [
        { icon: require("../assets/img/product-group_4-icon_5.png"), name: "信息处理模块" },
        { icon: require("../assets/img/product-group_4-icon_6.png"), name: "材料设备模块" },
        { icon: require("../assets/img/product-group_4-icon_7.png"), name: "进度控制模块" },
        { icon: require("../assets/img/product-group_4-icon_8.png"), name: "安全管理模块" }
      ],
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "",
            src: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770887780725_272_product.mp4"
          }
        ],
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      }
    };
  },
  components: {
    Banner
  },
  created() {
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.product-content {
  max-width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.section {
  padding: 60px 40px;

  &-header {
    text-align: center;
    margin-bottom: 50px;

    .title {
      font-size: 36px;
      font-weight: 600;
      color: #1a75bb;
      margin-bottom: 8px;
    }

    .eTitle {
      font-size: 16px;
      color: #999;
      letter-spacing: 4px;
      font-weight: 400;
    }

    .section-line {
      width: 50px;
      height: 3px;
      background: linear-gradient(90deg, #1a75bb, #4da8e8);
      margin: 15px auto 0;
      border-radius: 2px;
    }
  }
}

.section-video {
  .p-video {
    max-width: 900px;
    margin: 0 auto;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  }
}

.section-lacking {
  background: linear-gradient(135deg, #f5f9ff 0%, #eef5fc 100%);

  .lacking-bottom {
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;

    .lacking-bottom-item {
      width: 280px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      background: #fff;
      border-radius: 16px;
      padding: 35px 25px;
      box-shadow: 0 4px 20px rgba(26, 117, 187, 0.08);
      transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 35px rgba(26, 117, 187, 0.15);

        .lacking-bottom-item-img {
          background: #1a75bb;
          transform: scale(1.05);
        }
      }

      .lacking-bottom-item-img {
        width: 100px;
        height: 100px;
        background: linear-gradient(135deg, #1a75bb, #14679f);
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        transition: all 0.4s ease;
        box-shadow: 0 4px 15px rgba(26, 117, 187, 0.3);

        img {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }
      }

      h4 {
        font-size: 18px;
        color: #333;
        margin-bottom: 12px;
        font-weight: 600;
      }

      p {
        font-size: 14px;
        color: #666;
        line-height: 1.7;
        text-align: center;
      }
    }
  }
}

.section-target {
  .target-img {
    text-align: center;
    padding: 20px;

    img {
      max-width: 100%;
      border-radius: 12px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.1);
    }
  }
}

.section-modular {
  background: linear-gradient(135deg, #f5f9ff 0%, #eef5fc 100%);

  .modular-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    padding: 20px 0;
  }
}

.modular-content-same {
  width: 200px;
  display: flex;
  flex-direction: column;
  gap: 25px;

  .same-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    background: #fff;
    padding: 12px 16px;
    border-radius: 50px;
    box-shadow: 0 3px 12px rgba(0,0,0,0.06);
    transition: all 0.3s ease;

    &:hover {
      transform: translateX(5px);
      box-shadow: 0 6px 20px rgba(26, 117, 187, 0.12);

      .same-item-img {
        background: #1a75bb;
      }
    }

    .same-item-img {
      width: 48px;
      height: 48px;
      min-width: 48px;
      background: linear-gradient(135deg, #1a75bb, #14679f);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      img {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }
    }

    p {
      color: #333;
      font-weight: 600;
      font-size: 15px;
      white-space: nowrap;
    }
  }

  &.right .same-item {
    &:hover {
      transform: translateX(-5px);
    }
  }
}

.modular-content-center {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    max-width: 280px;
    filter: drop-shadow(0 8px 20px rgba(26, 117, 187, 0.2));
  }
}

// 响应式设计
@media (max-width: 992px) {
  .section {
    padding: 40px 20px;
  }

  .modular-content {
    flex-wrap: wrap;

    .modular-content-center {
      order: -1;
      width: 100%;
      height: auto;
      margin-bottom: 20px;

      img {
        max-width: 200px;
      }
    }

    .modular-content-same {
      width: 100%;
      max-width: 400px;
    }
  }
}

@media (max-width: 768px) {
  .section-header .title {
    font-size: 28px;
  }

  .lacking-bottom-item {
    width: 100% !important;
    max-width: 320px;
  }
}

@media (max-width: 576px) {
  .section {
    padding: 30px 15px;
  }

  .section-header .title {
    font-size: 24px;
  }

  .modular-content-same .same-item {
    p {
      font-size: 13px;
    }

    .same-item-img {
      width: 40px;
      height: 40px;
      min-width: 40px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
